import axiosInstance from '../utils/axios';

/**
 * 보안 모니터링 관련 API 서비스
 */
const securityMonitoringService = {
  /**
   * 대시보드 개요 정보 조회
   * @param {string} timeRange 시간 범위 (기본값: 24h)
   * @returns {Promise<Object>} 대시보드 데이터
   */
  async getDashboardOverview(timeRange = '24h') {
    try {
      const response = await axiosInstance.get('/alert-dashboard/overview', {
        params: { time_range: timeRange }
      });
      
      if (response.data.success) {
        return {
          success: true,
          data: response.data.data
        };
      }
      
      return {
        success: false,
        message: response.data.message || '대시보드 정보를 불러오는데 실패했습니다.'
      };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || '대시보드 정보를 불러오는 중 오류가 발생했습니다.';
      return {
        success: false,
        message: errorMessage
      };
    }
  },

  /**
   * 최근 보안 이벤트 목록 조회
   * @param {number} limit 조회할 이벤트 수 (기본값: 20)
   * @returns {Promise<Object>} 보안 이벤트 목록
   */
  async getRecentSecurityEvents(limit = 20) {
    try {
      const response = await axiosInstance.get('/security-alerts/security-events', {
        params: { limit }
      });
      
      if (response.data.success && response.data.data && response.data.data.events) {
        return {
          success: true,
          data: response.data.data.events
        };
      }
      
      return {
        success: false,
        message: response.data.message || '보안 이벤트를 불러오는데 실패했습니다.',
        data: []
      };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || '보안 이벤트를 불러오는 중 오류가 발생했습니다.';
      return {
        success: false,
        message: errorMessage,
        data: []
      };
    }
  }
};

export default securityMonitoringService;
